// extracted by mini-css-extract-plugin
module.exports = {"root":"RatingRow_root__2OxaH","label":"RatingRow_label__3QZ92","stars":"RatingRow_stars__h95g3","starEmpty":"RatingRow_starEmpty__14q1a"};